<template>
  <div class="link-header-logo">
    <co-tips
      :content="logoInfo.title"
      placement="bottom"
    >
      <a
        class="lenovo-link"
        :href="[isThirdparty ? '/user/login' : '#']"
      >
        <img
          v-if="logoInfo.logo"
          class="custom-logo"
          src="/v2/config/get_file?config_type=0&config_id=0&name=custom_main_logo"
          :alt="logoInfo.title"
        >
        <svg
          v-else
          class="lenovo-logo"
        >
          <use xlink:href="#logo" />
        </svg>
      </a>
    </co-tips>
  </div>
</template>
<script>
import coTips from 'components/common/tips/index.vue'

export default {
  components: {
    coTips,
  },
  props: {
    vipCustomization: {
      type: Boolean,
      default: false,
    },
    logoInfo: {
      type: Object,
      default: () => ({
        logo: '',
        title: '海信网盘',
      }),
    },
    isThirdparty: {
      type: Boolean,
      default: true,
    },
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.link-header-logo{
  display: inline-block;
  max-width: 300px;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  .lenovo-link{
    display: inline-block;
    height: 50px;
    width: auto;
  }
  /**自定义logo*/
  .custom-logo{
    max-width: 300px;
    max-height: 50px;
  }
  /**默认Lenovo logo*/
  .lenovo-logo{
    width: 208px;
    height: 20px;
    line-height: 50px;
    margin: 15px auto;
  }
}
</style>
